import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-cities-to',
    templateUrl: './cities-to.component.html',
    styleUrls: ['./cities-to.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CitiesToComponent {

}
